export const getCombinationString = (
  combinationString: string,
  returnedValue?: string
) => {
  if (combinationString && combinationString.toUpperCase() === "NONE") {
    return returnedValue ? returnedValue : "Variante única";
  } else {
    return combinationString;
  }
};

/**
 * Nombre del producto con la variante al lado: "Alimento para perros 15kg".
 *
 * Para comprobantes (ticket, PDF de la orden), donde la variante tiene que
 * viajar pegada al nombre y no en una linea aparte: dos variantes del mismo
 * producto salian con la misma linea y el cliente no podia distinguirlas.
 *
 * Devuelve el titulo solo cuando no hay variante real — `NONE` es la
 * pseudo-variante de los productos sin combinaciones.
 */
export const withVariant = (
  title: string,
  combinationString?: string | null
): string => {
  const variant = (combinationString ?? "").trim();
  if (!variant || variant.toUpperCase() === "NONE") return title;
  return `${title} ${variant}`;
};
